export default __webpack_public_path__ + "static/powerfoxmedia-7bc8782442d76cb3527e4b9f4e5c779e.png";